// extracted by mini-css-extract-plugin
module.exports = {"mainMenu":"mainMenu__14qv5"};